import React, {Component} from 'react';
import css from './Training.module.scss';
import SectionHeading from "../../components/SectionHeading/SectionHeading";

/**
 * @class
 *
 * Training page.
 * This page embeds an external YouTube video <iframe>.
 */
const Training = class extends Component {
    
    state = {
        soloPitch: false,
        showPitch: false,
        showPrelim: false,
        showPost: false,
        showMental: false,
        activeTab: ''
    };

    showSection (value) {
        switch (value) {
            case 'soloPitch' :
                this.setState(prevState => ({
                    soloPitch: !prevState.soloPitch,
                    showPitch: false,
                    showPrelim: false,
                    showPost: false,
                    showMental: false,
                    activeTab: 'soloPitch'
                }));
            break;

            case 'showPitch' :
                this.setState(prevState => ({
                    showPitch: !prevState.showPitch,
                    soloPitch: false,
                    showPrelim: false,
                    showPost: false,
                    showMental: false,
                    activeTab: 'showPitch'
                }));
            break;

            case 'showPrelim' : 
                this.setState(prevState => ({
                    showPrelim: !prevState.showPrelim,
                    soloPitch: false,
                    showPitch: false,
                    showPost: false,
                    showMental: false,
                    activeTab: 'showPrelim'
                }));
            break;

            case 'showPost' :
                this.setState(prevState => ({
                    showPost: !prevState.showPost,
                    soloPitch: false,
                    showPrelim: false,
                    showPitch: false,
                    showMental: false,
                    activeTab: 'showPost'
                }));
            break;

            case 'showMental' :
                this.setState(prevState => ({
                    showMental: !prevState.showMental,
                    soloPitch: false,
                    showPrelim: false,
                    showPost: false,
                    showPitch: false,
                    activeTab: 'showMental'
                }));
            break;

            default:
            break;
        }
    }

    activeTabCss (value) {
        return this.state.activeTab === value ? css.ActiveTab : null;
    }

    render () {
        return (
            <div className={css.Training}>
                <SectionHeading heading="Training" />

                <h2><a className='text-primary' href="https://sites.google.com/v3electric.com/v3-sales-training/training" target="_blank" rel="noreferrer noopener">2023 Training Site</a></h2>
                <nav className={css.Training__Nav}>
                    <ul>
                        <li className={this.activeTabCss('soloPitch')} onClick={() => this.showSection('soloPitch')}>Solo Pitch</li>
                        { this.state.soloPitch ? 
                            <div>
                                <br></br>
                                <h2>&ensp;Jake M - Solo Close Pioneer</h2>
                                <div className={css.Training__Container}>
                                    <iframe 
                                        className={css.Training__Responsive}
                                        src="https://www.youtube.com/embed/OaMcbaS0t7I"
                                        title="YouTube video player" 
                                        loading="lazy"
                                        frameborder="0" 
                                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" 
                                        allowfullscreen
                                    ></iframe>
                                </div>
                                <br></br>
                                <h2>&ensp;Jake M - Solo Close Amador</h2>
                                <div className={css.Training__Container}>
                                    <iframe 
                                        className={css.Training__Responsive}
                                        src="https://www.youtube.com/embed/Y5wdFzF8Hjg" 
                                        title="YouTube video player" 
                                        loading="lazy"
                                        frameborder="0" 
                                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" 
                                        allowfullscreen
                                    ></iframe>
                                </div>
                            </div>
                            :
                            ''
                        }
                        <li className={this.activeTabCss('showPitch')} onClick={() => this.showSection('showPitch')}>Pitch Help</li>
                        { this.state.showPitch ? 
                            <div>
                                <br></br>
                                <h2>&ensp;Corbridge Body Language</h2>
                                <div className={css.Training__Container}>
                                    <iframe 
                                        className={css.Training__Responsive}
                                        src="https://www.youtube.com/embed/eZYp-ShQEK4"
                                        title="YouTube video player" 
                                        loading="lazy"
                                        frameborder="0" 
                                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" 
                                        allowfullscreen
                                    ></iframe>
                                </div>
                                <br></br>
                                <h2>&ensp;Corbridge's Pitch</h2>
                                <div className={css.Training__Container}>
                                    <iframe 
                                        className={css.Training__Responsive}
                                        src="https://www.youtube.com/embed/_Tu8I_YBBvI" 
                                        title="YouTube video player"
                                        loading="lazy"
                                        frameborder="0" 
                                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" 
                                        allowfullscreen
                                    ></iframe>
                                </div>
                                <br></br>
                                <h2>&ensp;Javier's Pitch</h2>
                                <div className={css.Training__Container}>
                                    <iframe 
                                        className={css.Training__Responsive}
                                        src="https://www.youtube.com/embed/b7HPHnXsLpc"
                                        title="YouTube video player"
                                        loading="lazy"
                                        frameborder="0" 
                                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" 
                                        allowfullscreen
                                    ></iframe>
                                </div>
                                <br></br>
                                <h2>&ensp;Tanner's Pitch</h2>
                                <div className={css.Training__Container}>
                                    <iframe
                                        className={css.Training__Responsive}
                                        src="https://www.youtube.com/embed/viaas5R0l3g"
                                        title="YouTube video player"
                                        loading="lazy"
                                        frameborder="0"
                                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                        allowfullscreen
                                    ></iframe>
                                </div>
                                <br></br>
                                <h2>&ensp;Mac's Pitch</h2>
                                <div className={css.Training__Container}>
                                    <iframe
                                        className={css.Training__Responsive}
                                        src="https://www.youtube.com/embed/kz0463Hcfgk"
                                        title="YouTube video player"
                                        loading="lazy"
                                        frameborder="0"
                                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                        allowfullscreen
                                    ></iframe>
                                </div>
                                <br></br>
                                <h2>&ensp;Tyson's Pitch</h2>
                                <div className={css.Training__Container}>
                                    <iframe
                                        className={css.Training__Responsive}
                                        src="https://www.youtube.com/embed/x4HBerLKdDY"
                                        title="YouTube video player"
                                        loading="lazy"
                                        frameborder="0"
                                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                        allowfullscreen
                                    ></iframe>
                                </div>
                                <br></br>
                                <h2>&ensp;Pitch Advice</h2>
                                <div className={css.Training__Container}>
                                    <iframe
                                        className={css.Training__Responsive}
                                        src="https://www.youtube.com/embed/HmsPA4Oj3us"
                                        title="YouTube video player"
                                        loading="lazy"
                                        frameborder="0"
                                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                        allowfullscreen
                                    ></iframe>
                                </div>
                                <br></br>
                                <h2>&ensp;Macneil Overcoming Objections</h2>
                                <div className={css.Training__Container}>
                                    <iframe
                                        className={css.Training__Responsive}
                                        title="training"
                                        loading="lazy"
                                        src="https://www.youtube.com/embed/xRaT4OA7HlQ"
                                        frameBorder="0"
                                        allow="autoplay; encrypted-media"
                                        allowFullScreen
                                    ></iframe>
                                </div>
                                <br></br>
                                <h2>&ensp;Peder Acknowledge Respond Redirect</h2>
                                <div className={css.Training__Container}>
                                    <iframe 
                                        className={css.Training__Responsive}
                                        src="https://www.youtube.com/embed/pHg5eC0mT3E"
                                        title="YouTube video player" 
                                        loading="lazy"
                                        frameborder="0" 
                                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" 
                                        allowfullscreen
                                    ></iframe>
                                </div>
                                <br></br>
                                <h2>&ensp;Peder Feel Felt Found</h2>
                                <div className={css.Training__Container}>
                                    <iframe 
                                        className={css.Training__Responsive}
                                        src="https://www.youtube.com/embed/mb0Y7lZxvOQ"
                                        title="YouTube video player"
                                        loading="lazy"
                                        frameborder="0" 
                                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" 
                                        allowfullscreen
                                    ></iframe>
                                </div>
                                <br></br>
                                <h2>&ensp;What Is A Lead</h2>
                                <div className={css.Training__Container}>
                                    <iframe 
                                        className={css.Training__Responsive}
                                        src="https://www.youtube.com/embed/P96AoN0Te4M"
                                        title="YouTube video player"
                                        loading="lazy"
                                        frameborder="0" 
                                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" 
                                        allowfullscreen
                                    ></iframe>
                                </div>
                            </div>
                            :
                            ''
                        }
                        <li className={this.activeTabCss('showPrelim')} onClick={() => this.showSection('showPrelim')}>Prelim Help</li>
                        { this.state.showPrelim ? 
                            <div>
                                <br></br>
                                <h2>&ensp;Corbridge Prelim 10 Steps</h2>
                                <div className={css.Training__Container}>
                                    <iframe 
                                        className={css.Training__Responsive}
                                        src="https://www.youtube.com/embed/yW67USGNLD4?list=PLUTSSSJf2XxTM_WuADBItcX-kTPUL_OcJ" 
                                        title="YouTube video player"
                                        loading="lazy"
                                        frameborder="0" 
                                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" 
                                        allowfullscreen
                                    ></iframe>
                                </div>
                                <br></br>
                                <h2>&ensp;Prelim Intro</h2>
                                <div className={css.Training__Container}>
                                    <iframe 
                                        className={css.Training__Responsive}
                                        src="https://www.youtube.com/embed/-F6EilS15ag"
                                        title="YouTube video player"
                                        loading="lazy"
                                        frameborder="0" 
                                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" 
                                        allowfullscreen
                                    ></iframe>
                                </div>
                                <br></br>
                                <h2>&ensp;Prelim Step 1</h2>
                                <div className={css.Training__Container}>
                                    <iframe 
                                        className={css.Training__Responsive}
                                        src="https://www.youtube.com/embed/OokzY5bIslI"
                                        title="YouTube video player"
                                        loading="lazy"
                                        frameborder="0" 
                                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" 
                                        allowfullscreen
                                    ></iframe>
                                </div>
                                <br></br>
                                <h2>&ensp;Prelim Step 2</h2>
                                <div className={css.Training__Container}>
                                    <iframe 
                                        className={css.Training__Responsive}
                                        src="https://www.youtube.com/embed/f7IIaWgHsH0"
                                        title="YouTube video player"
                                        loading="lazy"
                                        frameborder="0" 
                                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" 
                                        allowfullscreen
                                    ></iframe>
                                </div>
                                <br></br>
                                <h2>&ensp;Prelim Step 3</h2>
                                <div className={css.Training__Container}>
                                    <iframe 
                                        className={css.Training__Responsive}
                                        src="https://www.youtube.com/embed/SU35MOQs-XI"
                                        title="YouTube video player"
                                        loading="lazy"
                                        frameborder="0" 
                                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" 
                                        allowfullscreen
                                    ></iframe>
                                </div>
                                <br></br>
                                <h2>&ensp;Prelim Step 4</h2>
                                <div className={css.Training__Container}>
                                    <iframe 
                                        className={css.Training__Responsive}
                                        src="https://www.youtube.com/embed/v_XdzCK3RtA"
                                        title="YouTube video player"
                                        loading="lazy"
                                        frameborder="0" 
                                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" 
                                        allowfullscreen
                                    ></iframe>
                                </div>
                                <br></br>
                                <h2>&ensp;Prelim Step 5 & 6</h2>
                                <div className={css.Training__Container}>
                                    <iframe 
                                        className={css.Training__Responsive}
                                        src="https://www.youtube.com/embed/dOI3WUkMac8"
                                        title="YouTube video player"
                                        loading="lazy"
                                        frameborder="0" 
                                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" 
                                        allowfullscreen
                                    ></iframe>
                                </div>
                                <br></br>
                                <h2>&ensp;Prelim Step 7</h2>
                                <div className={css.Training__Container}>
                                    <iframe 
                                        className={css.Training__Responsive}
                                        src="https://www.youtube.com/embed/XfruddEo4dY"
                                        title="YouTube video player"
                                        loading="lazy"
                                        frameborder="0" 
                                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" 
                                        allowfullscreen
                                    ></iframe>
                                </div>
                                <br></br>
                                <h2>&ensp;Prelim Step 8</h2>
                                <div className={css.Training__Container}>
                                    <iframe 
                                        className={css.Training__Responsive}
                                        src="https://www.youtube.com/embed/3K-8415_m0I"
                                        title="YouTube video player"
                                        loading="lazy"
                                        frameborder="0" 
                                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" 
                                        allowfullscreen
                                    ></iframe>
                                </div>
                                <br></br>
                                <h2>&ensp;Prelim Step 9</h2>
                                <div className={css.Training__Container}>
                                    <iframe 
                                        className={css.Training__Responsive}
                                        src="https://www.youtube.com/embed/pnqteBoffgQ" 
                                        title="YouTube video player"
                                        loading="lazy"
                                        frameborder="0" 
                                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" 
                                        allowfullscreen
                                    ></iframe>
                                </div>
                                <br></br>
                                <h2>&ensp;Macneil Overcoming Objections</h2>
                                <div className={css.Training__Container}>
                                    <iframe 
                                        className={css.Training__Responsive}
                                        src="https://www.youtube.com/embed/4ZmfQdayX0w"
                                        title="YouTube video player"
                                        loading="lazy"
                                        frameborder="0" 
                                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" 
                                        allowfullscreen
                                    ></iframe>
                                </div>
                                <br></br>
                                <h2>&ensp;Corbridge Selling to Why</h2>
                                <div className={css.Training__Container}>
                                    <iframe 
                                        className={css.Training__Responsive}
                                        src="https://www.youtube.com/embed/sWG3-MuIjPY"
                                        title="YouTube video player"
                                        loading="lazy"
                                        frameborder="0" 
                                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" 
                                        allowfullscreen
                                    ></iframe>
                                </div>
                            </div>
                            :
                            ''
                        }
                        <li className={this.activeTabCss('showPost')} onClick={() => this.showSection('showPost')}>Post Help</li> 
                        {
                            this.state.showPost ?
                            <div>
                                <br></br>
                                <h2>&ensp;Corbridge Post 10 Steps</h2>
                                <div className={css.Training__Container}>
                                    <iframe 
                                        className={css.Training__Responsive}
                                        src="https://www.youtube.com/embed/4UrgqDzu-Hw"
                                        title="YouTube video player"
                                        loading="lazy"
                                        frameborder="0" 
                                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" 
                                        allowfullscreen
                                    ></iframe>
                                </div>
                                <br></br>
                                <h2>&ensp;Jake Approaching Posts</h2>
                                <div className={css.Training__Container}>
                                    <iframe 
                                        className={css.Training__Responsive}
                                        src="https://www.youtube.com/embed/DxyOMqurNyQ" 
                                        title="YouTube video player"
                                        loading="lazy"
                                        frameborder="0" 
                                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" 
                                        allowfullscreen
                                    ></iframe>
                                </div>
                            </div>
                            :
                            ''
                        }
                        <li className={this.activeTabCss('showMental')} onClick={() => this.showSection('showMental')}>Mental Help</li>
                        {
                            this.state.showMental ?
                            <div>
                                <br></br>
                                <h2>&ensp;Corbridge Mindset</h2>
                                <div className={css.Training__Container}>
                                    <iframe 
                                        className={css.Training__Responsive}
                                        src="https://www.youtube.com/embed/XhyB7fHmSCc"
                                        title="YouTube video player"
                                        loading="lazy"
                                        frameborder="0" 
                                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" 
                                        allowfullscreen
                                    ></iframe>
                                </div>
                                <br></br>
                                <h2>&ensp;Corbridge Gratification</h2>
                                <div className={css.Training__Container}>
                                    <iframe 
                                        className={css.Training__Responsive}
                                        src="https://www.youtube.com/embed/gQsP6TugEhQ"
                                        title="YouTube video player"
                                        loading="lazy"
                                        frameborder="0" 
                                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" 
                                        allowfullscreen
                                    ></iframe>
                                </div>
                                <br></br>
                                <h2>&ensp;Corbridge Patience</h2>
                                <div className={css.Training__Container}>
                                    <iframe 
                                        className={css.Training__Responsive}
                                        src="https://www.youtube.com/embed/oeIO5t15_QQ"
                                        title="YouTube video player"
                                        loading="lazy"
                                        frameborder="0" 
                                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" 
                                        allowfullscreen
                                    ></iframe>
                                </div>
                                <br></br>
                                <h2>&ensp;Corbridge Set up Prelim</h2>
                                <div className={css.Training__Container}>
                                    <iframe 
                                        className={css.Training__Responsive}
                                        src="https://www.youtube.com/embed/0g910z5RyAQ" 
                                        title="YouTube video player"
                                        loading="lazy"
                                        frameborder="0" 
                                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" 
                                        allowfullscreen
                                    ></iframe>
                                </div>
                            </div>
                            :
                            ''
                        }
                    </ul>
                </nav>
            </div>
        );
    };
};

export default Training;
